import React from 'react';
import PropTypes from 'prop-types';
import './rss-link.scss';

// Icons
// ---------------------
import { ReactComponent as RSSIcon } from '../../assets/icons/rss-svgrepo-com.svg';

export const RSSLink = ({ path, aria, ...props }) => {
  return (
    <div className={`rss-link-component`}>
      <a className="rss-link" href={path}  target='rssXml' aria-label={aria ? aria : 'RSS Link'}>
        <RSSIcon />
        <span className="text">RSS</span>
      </a>
    </div>
  );
};

RSSLink.propTypes = {
  path: PropTypes.string,
};
